export default "__VITE_ASSET__8l0S$FeY__"